import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { CONTENT_CHANGES_ANCHOR } from '~/features/catalog-v2/components/product-journey-detail';
import { navContextSearchSchema } from '~/features/catalog-v2/utils/nav-context';

const searchSchema = z.object({
  productId: z.string().optional(),
  ...navContextSearchSchema,
});

/**
 * Legacy Compare URL — retired 2026-10-16: it repeated the product page's "Content generation
 * changes" table. Old links land on that product's table (or the Products tab when no product was
 * named), keeping the S8 `from`/`back` trail.
 */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/$runId/compare')({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    const { productId, ...nav } = search;
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw productId
      ? redirect({
          to: '/catalog-v2/runs/$runId/products/$productId',
          params: { runId: params.runId, productId },
          search: nav,
          hash: CONTENT_CHANGES_ANCHOR,
          replace: true,
        })
      : redirect({
          to: '/catalog-v2/runs/$runId/products',
          params: { runId: params.runId },
          replace: true,
        });
  },
});
